export default class {   
	constructor(container) {
		this._createElements(container);
		this._addEvents();

	}
	
	_createElements(container){
		this.container = container;
		this.closeBtn = this.container.querySelector('[data-aboutFav-close]');
	}

	_addEvents(){
		var self = this;
		this.closeBtn.onclick = function(){
			self.container.className = self.container.className.replace(/\s*js-active/, '');
			return false;
		}

	}

}







































